export const EXPORT_PRESETS = {
  essential: 'essential',
  all: 'all',
  none: 'none',
  custom: 'custom',
};

export const KARDEX_COLUMNS = [
  { key: 'fecha', label: 'Fecha', essential: true, group: 'Movimiento' },
  { key: 'transaccion', label: 'Transacción', essential: true, group: 'Movimiento' },
  { key: 'producto', label: 'Producto', essential: true, group: 'Movimiento' },
  { key: 'tipo', label: 'Tipo', essential: true, group: 'Movimiento' },
  { key: 'subTipo', label: 'Subtipo', group: 'Movimiento' },
  { key: 'cantidad', label: 'Cantidad', essential: true, group: 'Montos' },
  { key: 'precioUnit', label: 'Precio unit.', essential: true, group: 'Montos' },
  { key: 'total', label: 'Total', essential: true, group: 'Montos' },
  { key: 'metodoPago', label: 'Método pago', group: 'Movimiento' },
  { key: 'anulado', label: 'Anulado', group: 'Estado' },
];

export const STOCK_COLUMNS = [
  { key: 'producto', label: 'Producto', essential: true, group: 'Inventario' },
  { key: 'stock', label: 'Stock', essential: true, group: 'Inventario' },
  { key: 'valor', label: 'Valor inventario', essential: true, group: 'Montos' },
  { key: 'valorUnit', label: 'Valor promedio/u', essential: true, group: 'Montos' },
];

export const DATASET_CONFIG = {
  kardex: {
    title: 'Kardex',
    filename: 'kardex_inventario',
    columns: KARDEX_COLUMNS,
  },
  stock: {
    title: 'Inventario valorizado',
    filename: 'inventario_valorizado',
    columns: STOCK_COLUMNS,
  },
};

export function getColumnsForDataset(dataset) {
  return DATASET_CONFIG[dataset]?.columns || [];
}

export function getDefaultOrderedKeys(columns, preset = EXPORT_PRESETS.essential) {
  if (preset === EXPORT_PRESETS.none) return [];
  if (preset === EXPORT_PRESETS.all) return columns.map((c) => c.key);
  return columns.filter((c) => c.essential).map((c) => c.key);
}

export function sortKeysByColumnOrder(keys, columns) {
  const order = new Map(columns.map((c, i) => [c.key, i]));
  return [...keys].sort((a, b) => (order.get(a) ?? 999) - (order.get(b) ?? 999));
}

export function insertKeyInLogicalOrder(orderedKeys, newKey, columns) {
  const next = orderedKeys.includes(newKey) ? orderedKeys : [...orderedKeys, newKey];
  return sortKeysByColumnOrder(next, columns);
}

export function groupColumns(columns) {
  return columns.reduce((acc, col) => {
    const g = col.group || 'General';
    if (!acc[g]) acc[g] = [];
    acc[g].push(col);
    return acc;
  }, {});
}

export function getColumnLabel(columns, key) {
  return columns.find((c) => c.key === key)?.label || key;
}
